export interface Notification {
  id: string;
  category: 'all' | 'tasks' | 'benefits' | 'advisor';
  title: string;
  message: string;
  timestamp: string;
  read: boolean;
  actionLabel?: string;
  actionLink?: string;
}

export const mockNotifications: Notification[] = [
  {
    id: 'n1',
    category: 'tasks',
    title: 'Checklist Reminder',
    message: "Don't forget to book your 12-week ultrasound appointment",
    timestamp: '2025-11-03T09:00:00Z',
    read: false,
    actionLabel: 'View Checklist',
    actionLink: '/journey/new-mom/checklists',
  },
  {
    id: 'n2',
    category: 'advisor',
    title: 'Message from Sarah Chen',
    message: "I've prepared the maternity benefits summary you requested",
    timestamp: '2025-11-02T16:30:00Z',
    read: false,
    actionLabel: 'Read Message',
    actionLink: '/advisor',
  },
  {
    id: 'n3',
    category: 'benefits',
    title: 'New Wellness Program Available',
    message: 'Check out our prenatal yoga and nutrition workshops',
    timestamp: '2025-11-02T10:00:00Z',
    read: true,
    actionLabel: 'Learn More',
    actionLink: '/benefits/wellness',
  },
  {
    id: 'n4',
    category: 'tasks',
    title: 'Insurance Review Due',
    message: 'Your annual policy review is coming up next month',
    timestamp: '2025-11-01T14:00:00Z',
    read: true,
    actionLabel: 'Schedule Review',
    actionLink: '/advisor',
  },
  {
    id: 'n5',
    category: 'benefits',
    title: 'Claim Approved',
    message: 'Your recent medical claim has been processed successfully',
    timestamp: '2025-10-31T11:00:00Z',
    read: true,
    actionLabel: 'View Details',
    actionLink: '/benefits/claims',
  },
  {
    id: 'n6',
    category: 'advisor',
    title: 'Appointment Confirmed',
    message: 'Your consultation with Sarah Chen is scheduled for Nov 10',
    timestamp: '2025-10-30T09:00:00Z',
    read: true,
  },
];
